import React, {useEffect, useState} from 'react'
import { Navigate, useParams, useNavigate, Link } from 'react-router-dom'
import { ApiUrl, Headers } from '../services/ApiUrl';
import axios from 'axios'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ShareOnSocial from "react-share-on-social";
import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import VideoYoutube from './VideoYoutube';


const PropuestasDetalle = () => {
    const[idProyecto, setIdProyecto] = useState(0)
    const[detalleProyecto, setDetalleProyecto]= useState([])
    const[loadingDetalleProyecto, setLoadingDetalleProyecto]= useState(false)    
    let {id} = useParams()

  
    
    
    const cargarProyectoDetalle =(id)=>{
        setLoadingDetalleProyecto(true)
        //let url = ApiUrl + `relations?rel=users_proyectos,pp2023_proyectos&type=,user&select=*&linkTo=id_proyecto&equalTo=${id}`
        let url = ApiUrl + 'pp2023_proyectos_aprobados?select=*&linkTo=id_proyecto&equalTo=' + id
        axios.get(url, {headers:Headers})
        .then( response =>{
          setDetalleProyecto(response.data.results[0])
                //console.log(response)        
  
        }).catch( error=>{
          setDetalleProyecto([])
            //console.log(error)
  
        })
        .finally(function () {
            setLoadingDetalleProyecto(false)
        
        });         
    } 
    useEffect(() => {
      setIdProyecto(`${id}`)
      cargarProyectoDetalle(`${id}`)
    },[]);     


    const navigate = useNavigate();
    const navegarTo = () => {
        const destinourl = '/propuestas/';
        navigate(destinourl);
    }   

    return (
        <Container>
            <Row style={{marginTop:'30px'}}>
                <Col>
                    <Button onClick={()=>navegarTo()} variant="light"><i className="bi bi-arrow-left" style={{fontSize:'15px'}}></i> Ver todas las propuestas</Button>
                    <hr/>

                    <h3 style={{textWrap:'balance'}}>Propuesta #{detalleProyecto.id_proyecto} | {detalleProyecto.titulo_proyecto} </h3> 
                    <Badge bg="success">Propuesta Factible</Badge>
            <hr/>
            <div style={{fontSize:'18px'}}>
            <i className="bi bi-bookmarks"></i> Categoría: {detalleProyecto.categoria_proyecto}<br/>
            <i className="bi bi-geo-alt-fill"></i> Localidad: {detalleProyecto.localidad_proyecto}             
            </div>
            <hr/>
            <p><strong>Autores del proyecto:</strong> {detalleProyecto.autores_proyecto}</p>
            <p><strong>Descripción del proyecto:</strong> {detalleProyecto.descripcion_proyecto}</p>
            <p><strong>Localización:</strong> {detalleProyecto.localizacion}</p>

            <ListGroup style={{fontSize:'16px', marginBottom:'20px'}}>                                                              
                <ListGroup.Item><i className="bi bi-lightbulb icon-grey"></i> Tipo de proyecto: <strong>{detalleProyecto.tipo_proyecto}</strong> </ListGroup.Item>
                <ListGroup.Item><i className="bi bi-people-fill icon-grey"></i> Nombre del grupo: <strong>{detalleProyecto.nombre_grupo}</strong> </ListGroup.Item>                  
                <ListGroup.Item><i className="bi bi-person-vcard icon-grey"></i> Avales: <strong>{detalleProyecto.avales_proyecto}</strong> </ListGroup.Item>                  
            </ListGroup> 

            {detalleProyecto.video_youtube !=="" &&
                <VideoYoutube url={detalleProyecto.video_youtube} />                  
                }        
                                                                       
                        <ShareOnSocial
                    textToShare="Te comparto esta propuesta del Presupuesto Participativo de la Municipalidad de Rrenque Lauquen"
                    link={`https://trenquelauquen.gov.ar/pp2023/propuestas/${detalleProyecto.id_proyecto}`}
                    linkTitle="PP2023"
                    linkMetaDesc="Propuesta del Presupuesto Participativo de la Municipalidad de Rrenque Lauquen"
                    noReferer
                    
                    >
                    <Button variant="success" style={{marginTop:'30px'}}><i className="bi bi-share-fill"></i> Compartir la propuesta</Button>
                    </ShareOnSocial>


                </Col>
            </Row>
            
        </Container>

    )
}

export default PropuestasDetalle